import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { INewPort, INewPortInitialstate } from "./newportModel";
import {
  createNewPort,
  deleteNewPort,
  getAllActiveNewPort,
  getAllNewPort,
  getNewPortByID,
  newportActiveInactive,
  updateNewPort,
} from "./services/newport.services";

const initialState: INewPortInitialstate = {
  loading: false,
  formLoading: false,
  error: "",
  NewPortList: [],
  NewPortID: null,
  NewPortDetail: {
    port_name: "",
    short_code: "",
    city_id: null,
    isactive: 1,
  },
};

const newportSlice = createSlice({
  name: "newport",
  initialState,
  reducers: {
    clearNewPortDetails: (state) => {
      state.NewPortDetail = initialState.NewPortDetail;
    },
    setNewPortID: (state, action) => {
      state.NewPortID = action.payload;
    },
    clearNewPortID: (state) => {
      state.NewPortID = initialState.NewPortID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllNewPort.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllNewPort.fulfilled,
      (state, action: PayloadAction<INewPort[]>) => {
        state.loading = false;
        state.NewPortList = action.payload || [];
      }
    );
    builder.addCase(getAllNewPort.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.NewPortList = [];
    });
    builder.addCase(createNewPort.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createNewPort.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createNewPort.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateNewPort.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateNewPort.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateNewPort.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteNewPort.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteNewPort.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteNewPort.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getNewPortByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getNewPortByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.NewPortDetail = action.payload;
    });
    builder.addCase(getNewPortByID.rejected, (state, action) => {
      state.formLoading = false;
      state.NewPortDetail = initialState.NewPortDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveNewPort.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveNewPort.fulfilled,
      (state, action: PayloadAction<INewPort[]>) => {
        state.loading = false;
        state.NewPortList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveNewPort.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.NewPortList = [];
    });
    builder.addCase(newportActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(newportActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(newportActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearNewPortDetails, setNewPortID, clearNewPortID } =
  newportSlice.actions;
export default newportSlice.reducer;
